import { MY_DAY_STEP_STATUS } from '../../../common/utils/myDay/driverDaySteps';

export const MY_DAY_TRAINING_PERSONAL_STEP_KEYS = new Set([
	'clockIn',
	'leaveWarehouseChecklist',
	'returnedToWarehouse',
	'vehicleChecklist',
	'selfDebrief',
	'clockOut',
]);

const MY_DAY_TRAINING_FINAL_RETURN_STEP_KEYS = new Set([
	'moneyBags',
	'returnKeys',
	'returnStock',
]);

export const isMyDayTraining = trainingContext => Boolean(trainingContext?.runId &&
	trainingContext?.targetDriverId &&
	trainingContext?.scopeKey);

export const getMyDayTrainingRouteParams = trainingContext => (
	isMyDayTraining(trainingContext) ? { myDayTraining: trainingContext } : {}
);

export const getMyDayTrainingAllowedRunIds = (trainingContext) => {
	if (!isMyDayTraining(trainingContext)) {
		return [];
	}

	return Array.from(new Set([
		trainingContext.runId,
		...(trainingContext.runIds || []),
	].map(String).filter(Boolean)));
};

export const lockMyDayTrainingPersonalSteps = (steps, trainingContext) => {
	if (!isMyDayTraining(trainingContext)) {
		return steps;
	}

	return (steps || []).map((step) => {
		if (!MY_DAY_TRAINING_PERSONAL_STEP_KEYS.has(step.key)) {
			return step;
		}

		return {
			...step,
			required: false,
			blocksProgress: false,
			trainingUnavailable: true,
			status: step.status === MY_DAY_STEP_STATUS.HIDDEN
				? MY_DAY_STEP_STATUS.HIDDEN
				: MY_DAY_STEP_STATUS.BLOCKED,
			description: step.status === MY_DAY_STEP_STATUS.DONE
				? `${step.description} This recorded personal action remains unavailable in training mode.`
				: `Only ${trainingContext.targetDriverName} can complete this personal action. It does not block training.`,
		};
	});
};

export const lockMyDayTrainingEndSteps = ({
	steps,
	trainingContext,
	allAssignedRunsComplete,
}) => lockMyDayTrainingPersonalSteps(steps, trainingContext).map((step) => {
	if (
		!isMyDayTraining(trainingContext) ||
		allAssignedRunsComplete ||
		!MY_DAY_TRAINING_FINAL_RETURN_STEP_KEYS.has(step.key)
	) {
		return step;
	}

	return {
		...step,
		required: false,
		blocksProgress: false,
		trainingUnavailable: true,
		trainingBlockedByOtherRuns: true,
		status: step.status === MY_DAY_STEP_STATUS.HIDDEN
			? MY_DAY_STEP_STATUS.HIDDEN
			: MY_DAY_STEP_STATUS.BLOCKED,
		description: `Finish ${trainingContext.targetDriverName}'s other assigned runs before completing this final return action.`,
	};
});
